import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Testimonial.css";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Janvi",
      feedback: "Amazing Experience!",
      rating: 5,
      description:
        "The Sri Takshashila Gurukul app has transformed my learning journey. Highly recommend it!",
    },
    {
      name: "Smitha",
      feedback: "Excellent Service!",
      rating: 5,
      description:
        "The app is easy to use and has greatly improved my learning experience. Highly recommend!",
    },
    {
      name: "Suraj",
      feedback: "Happy Learner!",
      rating: 5,
      description:
        "Sri Takshashila Gurukul helped me enhance my skills. The courses are well informative.",
    },
    {
      name: "Shambhavi Kamkar",
      feedback: "Outstanding Experience!",
      rating: 5,
      description:
        "Sri Takshashila Gurukul skillfully combines spiritual and educational information.",
    },
  ];

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">TESTIMONIALS</h2>
      <div className="text-center mb-4">
        {/* Converted the Read More into a button */}
        <a href="#" className="btn btn-primary btn-lg testimonials-read-more">
          READ MORE
        </a>
      </div>
      <div className="row">
        {testimonials.map((testimonial, index) => (
          <div className="col-md-3 mb-4" key={index}>
            <div
              className="card testimonial-card h-100 shadow-sm"
              style={{
                background: "linear-gradient(160deg, rgba(2,0,36,1) 0%, rgba(223,80,48,0.95) 10%, rgba(219,219,142,1) 98%, rgba(0,212,255,1) 100%)", 
                color: "#000", 
              }}
            >
              <div className="card-body text-center">
                <div
                  className="rounded-circle mx-auto mb-3"
                  style={{
                    width: "80px",
                    height: "80px",
                    backgroundImage: `url(https://picsum.photos/80?random=${index})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                ></div>
                <h5 className="card-title">{testimonial.name}</h5>
                <p className="font-weight-bold">{testimonial.feedback}</p>
                <div className="text-warning mb-2">
                  {"⭐".repeat(testimonial.rating)}
                </div>
                <p>{testimonial.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
